import FilledMessageCircle from "@crehana/icons/fill/MessageCircle";
import MessageCircle from "@crehana/icons/outline/MessageCircle";
import { useMainMenuContext, useMainMenuTranslation } from "../../../../../../hooks";
import NavbarIconButtonWithHover from "../../../../../../ui/NavbarIconButtonWithHover";
import { jsx as _jsx } from "react/jsx-runtime";
var InboxLink = function InboxLink(_ref) {
  var className = _ref.className,
    numberNotification = _ref.numberNotification;
  var _useMainMenuTranslati = useMainMenuTranslation(),
    t = _useMainMenuTranslati.t;
  var _useMainMenuContext = useMainMenuContext(),
    me = _useMainMenuContext.me,
    urls = _useMainMenuContext.urls,
    layoutConfig = _useMainMenuContext.layoutConfig;
  return /*#__PURE__*/_jsx(NavbarIconButtonWithHover, {
    Icon: MessageCircle,
    FilledIcon: layoutConfig.newSidebarEnabled ? MessageCircle : FilledMessageCircle,
    label: t(me.isMentor ? 'INBOX_LABEL_FOR_MENTORS' : 'INBOX_LABEL'),
    href: urls.inbox,
    numberNotification: numberNotification,
    className: className,
    dataTour: "reactour__step2"
  });
};
export default InboxLink;